import type { AvatarProps } from '@workramp/ui';
import { useTheme } from 'styled-components';
import { Avatar } from '@workramp/ui';
import { getColorsForAvatar, getLettersForAvatar } from '~/utils/avatar';

export interface LearnerAvatarProps extends Omit<AvatarProps, 'letters' | 'backgroundColor' | 'foregroundColor'> {
  name?: string;
  brandColor?: string;
}

export function LearnerAvatar({ name, brandColor, ...props }: LearnerAvatarProps) {
  const theme = useTheme();

  // Generate initials
  const letters = getLettersForAvatar(name);

  // Generate custom colors
  const colors = getColorsForAvatar(theme, brandColor);

  return <Avatar letters={letters} {...colors} {...props} />;
}
